<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('assitive_device_management.patient_affairs_officer_demand_form')}}</h4>
            </template>
            <template v-slot:headerAction>
                <router-link to="psosk-demand-list" :class="'btn btn-primary text-light'">{{  $t('assitive_device_management.patient_affairs_officer_demand') }} {{  $t('globalTrans.list') }}</router-link>
            </template>
          <template v-slot:body>
            <b-overlay :show="loader">
                <b-row>
                    <b-col xl="12" lg="12" sm="12">
                        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                            <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset">
                                <b-row class="mt-2">
                                    <b-col lg="6"  sm="12">
                                        <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="fiscal_year_id"
                                                slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{$t('globalTrans.fiscal_year')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="formData.fiscal_year_id"
                                            :options="fiscalYearList"
                                            id="fiscal_year_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6" sm="12">
                                       <ValidationProvider name="Demand Date" vid="application_date" rules="required">
                                            <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="level"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{$t('assitive_device_management.demand_date')}}<span class="text-danger">*</span>
                                            </template>
                                            <b-form-input
                                                plain
                                                class="budgetDate"
                                                v-model="formData.application_date"
                                                :placeholder="$t('assitive_device_management.demand_date')"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                >
                                            </b-form-input>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6"  sm="12">
                                        <ValidationProvider name="Division Name" vid="pre_division_id" rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="pre_division_id"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{$t('org_pro_division.division')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                    plain
                                                    v-model="formData.pre_division_id"
                                                    :options="divisionList"
                                                    id="pre_division_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    :disabled="activeCenter.division_id > 0"
                                                >
                                                <template v-slot:first>
                                                    <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6"  sm="12">
                                        <ValidationProvider name="District Name" vid="pre_district_id">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="pre_district_id"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{$t('org_pro_district.district')}}
                                                </template>
                                                <b-form-select
                                                    plain
                                                    v-model="formData.pre_district_id"
                                                    :options="districtList"
                                                    id="pre_district_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    :disabled="activeCenter.district_id > 0"
                                                >
                                                <template v-slot:first>
                                                    <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6"  sm="12">
                                        <ValidationProvider name="PSOSK Name" vid="center_id" rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="center_id"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                    {{$t('assitive_device_management.idsc_center')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                    plain
                                                    v-model="formData.center_id"
                                                    :options="idscCenterList"
                                                    id="center_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    :disabled="activeCenter.value > 0"
                                                >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                                <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                                <hr>
                                <b-overlay :show="loadData">
                                <b-row class="mt-2" >
                                    <b-col lg="6"  sm="12">
                                        <ValidationProvider name="Assistive Device" vid="assistive_device_id" rules="">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="assistive_device_id"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                    {{$t('assitive_device_management.assistive_device_name')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                    plain
                                                    v-model="detailsFormData.assistive_device_id"
                                                    :options="assistiveDeviceList"
                                                    id="assistive_device_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                                <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6" sm="12">
                                        <ValidationProvider name="Demand Quantity" vid="no_of_quantity">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="no_of_quantity"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                    {{ $t('assitive_device_management.demand_quantity')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-input
                                                    id="no_of_quantity"
                                                    v-model="detailsFormData.no_of_quantity"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                                </b-overlay>
                                <div class="row">
                                    <div class="col-sm-3"></div>
                                    <div class="col text-right">
                                        <b-button type="button" @click="addTmp()" variant="primary" class="mr-2">{{ $t('institute_manangement.add') }}</b-button>
                                    </div>
                                </div>
                                <br/>
                                <b-table-simple  bordered>
                                    <thead>
                                        <tr class="bg-primary">
                                            <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                            <th>{{ $t('assitive_device_management.assistive_device_name') }}</th>
                                            <th>{{ $t('assitive_device_management.demand_quantity') }}</th>
                                            <th>{{ $t('globalTrans.action') }}</th>
                                        </tr>
                                        </thead>
                                        <b-tbody>
                                            <b-tr v-for="(item, index) in formData.details" :key="index">
                                                <b-td>
                                                    {{ $n(index + 1) }}
                                                </b-td>
                                                <b-td>
                                                    <ValidationProvider vid="assistive_device_id">
                                                        <b-form-group
                                                            slot-scope="{ valid, errors }"
                                                            class="mb-0"
                                                        >
                                                            <b-form-select
                                                                plain
                                                                disabled
                                                                id="assistive_device_id"
                                                                v-model="item.assistive_device_id"
                                                                :options="assistiveDeviceList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-td>
                                                 <b-td>
                                                    <ValidationProvider name="Pass Mark" vid="no_of_quantity" rules="">
                                                        <b-form-group
                                                            slot-scope="{ valid, errors }"
                                                            class="mb-0"
                                                        >
                                                            <b-form-input class="form-control"
                                                                v-model="item.no_of_quantity"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                @input="getGrandTotalInfo"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-td>
                                                <b-td>
                                                    <b-button type="button" @click="remove(index)" class="btn btn- iq-bg-danger btn-sm text-center ml-1"><i class="ri-delete-bin-line m-0"></i></b-button>
                                                </b-td>
                                            </b-tr>
                                        </b-tbody>
                                    <b-tfoot>
                                        <b-tr>
                                            <b-th colspan="2" class="text-right">{{ $t('sitePreference.grandTotal') }}</b-th>
                                            <b-th class="text-right">{{ grandTotalInfo.demand_quantity }}</b-th>
                                            <b-th></b-th>
                                        </b-tr>
                                    </b-tfoot>
                                    </b-table-simple>
                                    <div class="row">
                                    <div class="col-sm-3"></div>
                                    <div class="col text-right">
                                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                        &nbsp;
                                    <router-link to="psosk-demand-list" :class="'btn btn-danger text-light'">{{ $t('globalTrans.cancel') }}</router-link>
                                    </div>
                                </div>
                            </b-form>
                        </ValidationObserver>
                    </b-col>
                </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { psoskDemandStore, assistiveDeviceData, psoskDemandUpdate, psoskDemandShow } from '../../api/routes'
import flatpickr from 'flatpickr'

const today = new Date().toISOString().substr(0, 10)
export default {
    name: 'FormLayout',
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data () {
        return {
            saveBtnName: this.$route.query.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            loader: false,
            loadData: false,
            formData: {
                fiscal_year_id: '',
                pre_division_id: 0,
                pre_district_id: 0,
                center_id: 0,
                application_date: today,
                details: []
            },
            detailsFormData: {
                assistive_device_id: 0,
                no_of_quantity: ''
            },
            districtList: [],
            idscCenterList: [],
            grandTotalInfo: {
                demand_quantity: 0
            },
            activeCenter: {
                value: 0,
                division_id: 0,
                district_id: 0
            }
        }
    },
    created () {
        if (this.$store.state.dataFilters.officeId) {
          const centerOfficeId = this.$store.state.dataFilters.officeId
          this.activeCenter = this.centerList.find(item => item.office_id === parseInt(centerOfficeId) && item.sales_center_type === 1)
          this.formData = Object.assign({}, this.formData, {
              pre_division_id: this.activeCenter.division_id,
              pre_district_id: this.activeCenter.district_id,
              center_id: this.activeCenter.value
          })
        }
        if (this.$route.query.id) {
            this.getExamData()
        }
    },
    mounted () {
        core.index()
        flatpickr('.budgetDate', {})
        this.formData = Object.assign({}, this.formData, { fiscal_year_id: this.$store.state.currentFiscalYearId })
    },
    computed: {
        centerList: function () {
            return this.$store.state.AwarenessEventService.commonObj.idscCenterList
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
        },
        divisionList: function () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        assistiveDeviceList: function () {
            return this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.filter(item => item.status === 1)
        },
        currentLocale () {
            return this.$i18n.locale
        },
        currentFiscalYearId () {
            return this.$store.state.currentFiscalYearId
        }
  },
  watch: {
        'formData.pre_division_id': function (newVal, oldVal) {
            this.districtList = this.getDistrictList(newVal)
            this.idscCenterList = this.getIDSCDivisionList(newVal)
        },
        'formData.pre_district_id': function (newVal, oldVal) {
            this.idscCenterList = this.getIDSCDistrictList(newVal)
        }
  },
    methods: {
       async totalDemandQuantity (Id) {
        if (Id) {
            this.loadData = true
            const formData = {
                assistive_device_id: this.detailsFormData.assistive_device_id,
                fiscal_year_id: this.formData.fiscal_year_id
            }
            const result = await RestApi.getData(awarenessEventServiceBaseUrl, assistiveDeviceData, formData)
            if (result.success) {
                this.getRelationalData(result.data)
                this.loadData = false
            } else {
                this.$toast.error({
                    title: 'error',
                    message: result.message,
                    color: '#D6E09B'
                })
                this.loadData = false
                this.reset()
            }
        } else {
            this.reset()
        }
      },
        getRelationalData (data) {
            this.detailsFormData.no_of_quantity = data
        },
        addTmp () {
            const obj = {
                assistive_device_id: this.detailsFormData.assistive_device_id,
                no_of_quantity: this.detailsFormData.no_of_quantity
            }
            const objExist = this.formData.details.find(detail => detail.assistive_device_id === obj.assistive_device_id)
            if (typeof objExist === 'undefined') {
                if (this.detailsFormData.no_of_quantity !== '' && this.detailsFormData.assistive_device_id !== 0) {
                    this.formData.details.push(obj)
                    this.getGrandTotalInfo()
                    this.reset()
                    this.$nextTick(() => {
                        this.$refs.form.reset()
                    })
                }
            } else {
                this.$toast.error({
                    title: 'Data has already been added',
                    color: '#D6E09B'
                })
            }
        },
        remove (index) {
            this.formData.details.splice(index, 1)
            this.getGrandTotalInfo()
        },
        getDescription (Id) {
            const Obj = this.$store.state.AwarenessEventService.commonObj.serviceTypeList.find(item => item.value === Id)
            return Obj
        },
        async getExamData () {
            this.loader = true
            const resultData = await RestApi.getData(awarenessEventServiceBaseUrl, psoskDemandShow + '/' + this.$route.query.id)
            const tmpData = resultData.data
            const detailsData = tmpData.details.map(item => {
                return { assistive_device_id: item.assistive_device_id, no_of_quantity: item.no_of_quantity }
            })
            this.formData.details = detailsData
            this.formData = tmpData
            this.getGrandTotalInfo()
            this.loader = false
        },
        async storeUpdate () {
            if (!this.formData.details.length) {
                return this.$toast.error({
                    title: this.$t('globalTrans.error'),
                    message: 'Please add device info',
                    color: '#910f06'
                })
            }
            this.loader = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }

            if (this.$route.query.id) {
                result = await RestApi.putData(awarenessEventServiceBaseUrl, `${psoskDemandUpdate}/${this.$route.query.id}`, this.formData)
            } else {
                result = await RestApi.postData(awarenessEventServiceBaseUrl, psoskDemandStore, this.formData)
            }

            this.$store.dispatch('mutateCommonProperties', loadinState)

            if (result.success) {
                this.loader = false
                this.$store.dispatch('AwarenessEventService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.$route.query.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })

                this.$router.push('/awareness-event-service/assistive-device-management/psosk-demand-list')
            } else {
                this.loader = false
                if (result.errors) {
                  this.$refs.form.setErrors(result.errors)
                } else {
                  this.$toast.error({
                    title: this.$t('globalTrans.success'),
                    message: result.message,
                    color: '#a61927'
                  })
                }
            }
        },
        reset () {
            this.detailsFormData = {
                assistive_device_id: 0,
                    no_of_quantity: '',
                    requisition_quantity: '',
                    unit_price: '',
                    total_price: ''
            }
        },
        getGrandTotalInfo () {
           let totalDemandQuantity = 0
            this.formData.details.forEach(item => {
                totalDemandQuantity += parseFloat(item.no_of_quantity)
            })
            this.grandTotalInfo = Object.assign({}, this.grandTotalInfo, {
               demand_quantity: totalDemandQuantity
            })
        },
        getDistrictList (divisionId = null) {
            const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

            if (divisionId) {
                return districtList.filter(district => district.division_id === divisionId)
            }

            return districtList
        },
        getIDSCDistrictList (idscCenterId = null) {
            const idscCenterList = this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.sales_center_type === 1)

            if (idscCenterId) {
                return idscCenterList.filter(item => item.district_id === idscCenterId)
            }

            return idscCenterList
        },
        getIDSCDivisionList (idscCenterId = null) {
            const idscCenterList = this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.sales_center_type === 1)

            if (idscCenterId) {
                return idscCenterList.filter(item => item.division_id === idscCenterId)
            }

            return idscCenterList
        }
    }
}
</script>
